module.exports = __webpack_public_path__ + "img/other-icon.bc43d1bf.svg";